/**
 * Shared constants, hooks and tiny components for the Agent portal modules.
 *
 * Extracted from the monolithic AgentPortal.js during the iter35 refactor to keep
 * each module focused on a single screen / responsibility.
 */
import React from "react";
import { Check } from "lucide-react";
import { useCompany } from "../../context/CompanyContext";
import { formatMoney } from "../../utils/currency";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/** Hook: returns a currency formatter using the active company + display mode. */
export const useFmt = () => {
  const { company, displayMode } = useCompany();
  return (v) => formatMoney(v, company, { displayMode });
};

/** Order status -> i18n label map (called with current translations dict). */
export const statusLabelMap = (t) => ({
  draft: "📝 Provvisorio",
  pending_agent: t.statusPendingAgent,
  pending: t.statusPending,
  confirmed: t.statusConfirmed,
  in_preparation: t.statusInPrep,
  ready: t.statusReady,
  shipped: t.statusShipped,
  delivered: t.statusDelivered,
  completed: t.statusCompleted,
  cancelled: t.statusCancelled,
});

export const STATUS_COLOR = {
  draft: "bg-stone-200 text-stone-700 border border-stone-300",
  pending_agent: "bg-amber-100 text-amber-800",
  pending: "bg-yellow-100 text-yellow-700",
  confirmed: "bg-blue-100 text-blue-700",
  in_preparation: "bg-orange-100 text-orange-700",
  ready: "bg-cyan-100 text-cyan-700",
  shipped: "bg-purple-100 text-purple-700",
  delivered: "bg-emerald-100 text-emerald-700",
  completed: "bg-green-100 text-green-700",
  cancelled: "bg-red-100 text-red-700",
};

export const Logo = ({ className = "h-8" }) => (
  <img
    src="https://customer-assets.emergentagent.com/job_sales-catalog-hub-1/artifacts/6bi5tskl_giotto-hor-bordo-carni%20%282%29.png"
    alt="Giotto Carni"
    className={className}
  />
);

/** Empty-state icon for "Nessun ordine da approvare" screen. */
export const CheckCircle2BigIcon = () => (
  <div className="w-16 h-16 mx-auto rounded-full bg-green-100 flex items-center justify-center">
    <Check className="w-8 h-8 text-green-600" />
  </div>
);
